<template>
	<div class="home">
		<Header ref="header" :type='headType'></Header>
		<BanIn url="image002">
			<template v-slot:text>
				<h2 class="inTit f48 wow fadeInLeft">联系我们</h2>
				<div class="inDes f24 wow fadeInRight">
					<p>提供仓储、装卸、简单包装、配送、库存管理、信息处理、咨询等“一站式”综合物流服务</p>
				</div>
			</template>
		</BanIn>
        <div class="mainBg">
			<div class="conBg">
				<div class="wrap">
                    <div class="hmTit text-center wow fadeInDown">
                        <h2 class="hmTitCn f40 color0">联系我们</h2>
                    </div>
                    <ul class="sortList wow fadeInUp" id="anchor">						
						<li class="active"><router-link to="/contact">联系我们</router-link></li>
						<li><router-link to="/join">加入我们</router-link></li>
                    </ul>
					<ul class="conList" v-if="conList.length">
						<li class="flex align-center" v-for="(item, index) in conList" :key="index">
							<div class="conMap wow fadeInLeft">
								<a :href="item.url" target="_blank"><img v-if="item.image" :src="item.image" alt=""></a>
								<!-- <baidu-map v-else class="map" :center="{lng: 116.404, lat: 39.915}" :zoom="15">
									<bm-marker :position="{lng: 116.404, lat: 39.915}"  animation="BMAP_ANIMATION_BOUNCE" :icon="{url: mapIcon, size: {width: 24, height: 34}}">
									</bm-marker>
								</baidu-map> -->
							</div>
							<div class="conText wow fadeInRight">
								<div class="conCon">
									<h3 class="conTit f36 color6">{{item.title}}</h3>
									<div class="conInfo f16 color6">
										<p>联系电话：{{item.phone}}</p>
										<p>联系邮箱：{{item.email}}</p>
										<p>公司地址：{{item.address}}</p>
										<!-- <p>公司总部：北京市朝阳区望京SOHO T2 B座 1506</p> -->
									</div>
									<a class="hmMore conMore f18" :href="item.url" target="_blank">查看地图位置 +</a>
								</div>
							</div>
						</li>
					</ul>
					<el-empty v-else description="暂无内容"></el-empty>
				</div>
			</div>
		</div>
		<Message></Message>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header.vue'
	import BanIn from '@/components/BanIn.vue'
	import Message from '@/components/Message.vue'
	import Footer from '@/components/Footer.vue'
	import { WOW } from 'wowjs'
	import home from '../api/home'
	export default {
		name: 'Case',
		components: {
			Header,
			BanIn,
			Message,
			Footer
		},
		data() {
			return {
				headType:3,
				mapIcon:require('@/assets/images/icon/mapIcon.png'),
				conList: []
			}
		},
		watch: {
			conList () {
				this.$nextTick(()=>{
					new WOW({ boxClass:"wow",animateClass:"animated",offset:5,mobile:true,live:false,resetAnimation:true }).init()
				})
			}
		},
		mounted() {
			this.$nextTick(()=>{
				new WOW({ boxClass:"wow",animateClass:"animated",offset:5,mobile:true,live:false,resetAnimation:true }).init()
			});
			this.getlist();
		},
		methods:{
			getlist(){
				home.conList().then((res)=>{
					if (res.code === 1) {
						this.conList = res?.data.rows
						console.log(this.conList)
					} else {
						this.$toast(res.msg)
					}
				});
			}
		}
		
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/contact.scss';
</style>